package com.vizio.redwolf.dms.model

import com.vizio.redwolf.dms.LinkedDevicesResponse
import com.vizio.redwolf.utils.ResponseHeaders
import kotlin.js.JsExport

@JsExport
class PayNonceRequestResult(val headers:  ResponseHeaders, val response: PayNonceRequestResponse)

@JsExport
class PayNonceStatusResult(val headers:  ResponseHeaders, val response: PayNonceStatusResponse)

@JsExport
class PayNonceStatusFieldedResult(val headers:  ResponseHeaders, val response: PayNonceStatusFieldedResponse)

@JsExport
class NonceRegisterResult(val headers:  ResponseHeaders, val response: NonceRegisterResponse)

@JsExport
class UnregisterAllResult(val headers:  ResponseHeaders, val response: UnregisterAllResponse)

@JsExport
class LinkedDevicesResult(val headers:  ResponseHeaders, val response: LinkedDevicesResponse)

@JsExport
class VoiceLinkingResult(val headers: ResponseHeaders, val  response: VoiceLinkingResponse)

class RegistrationStatusResult(val headers: ResponseHeaders, val  response: RegistrationStatusResponse)
